import { render, staticRenderFns } from "./WhatsappTable.vue?vue&type=template&id=f1b9df0a&scoped=true&"
import script from "./WhatsappTable.vue?vue&type=script&lang=js&"
export * from "./WhatsappTable.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappTable.vue?vue&type=style&index=0&id=f1b9df0a&lang=scss&scoped=true&"
import style1 from "./WhatsappTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b9df0a",
  null
  
)

export default component.exports